import React from "react";

const Social = () => {
   return(
      <div className="home__social">
         <a href="https://www.linkedin.com/in/stuart-daniells/" className="home__social-icon" target="_blank" rel="noreferrer">
            <i class="uil uil-linkedin-alt"></i>
         </a>
         <a href="https://github.com/StuartDaniells" className="home__social-icon" target="_blank" rel="noreferrer">
            <i class="uil uil-github-alt"></i>
         </a>
         <a href="https://twitter.com/DaniellsStuart" className="home__social-icon" target="_blank" rel="noreferrer">
            <i class="uil uil-twitter-alt"></i>
         </a>
      </div>
   )
}

export default Social;